import { useEffect, useRef } from 'react'

import { Trans } from 'react-i18next'
import { MdPhone } from 'react-icons/md'
import { useLocation, useNavigate } from 'react-router-dom'

import { Layout, Text } from '../../components'
import { ERROR_TYPE, ErrorType, PATH } from '../../constants'
import { useDeviceIdProvider, useOnline, usePhoneNumber } from '../../hooks'

const BACK_TIME = 1000 * 60 * 3 // 3 minutes

export function MaintenanceFrame() {
  const navigate = useNavigate()
  const { getRoute, deviceId } = useDeviceIdProvider()
  const { phoneNumber } = usePhoneNumber(deviceId || null)
  const backTimer = useRef<NodeJS.Timeout | null>(null)
  const isOnline = useOnline()
  const {
    state,
  }: {
    state: {
      error: ErrorType
    }
  } = useLocation()

  useEffect(() => {
    if (state?.error === ERROR_TYPE.OFFLINE && isOnline) {
      navigate(getRoute(PATH.root))
    }
  }, [isOnline, navigate, getRoute, state?.error])

  useEffect(() => {
    backTimer.current = setTimeout(() => {
      navigate(getRoute(PATH.root))
    }, BACK_TIME)
  }, [getRoute, navigate])

  useEffect(
    () => () => {
      if (backTimer.current) {
        clearTimeout(backTimer.current)
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [location.pathname]
  )

  return (
    <Layout>
      <div className="mt-[40px] flex w-full flex-col items-center gap-y-[40px] leading-[2]">
        <div>
          <Text size="lg2" weight="bold" align="center">
            <Trans
              i18nKey="frames.MaintenanceFrame.information"
              tOptions={{ lng: 'ja' }}
            />
          </Text>
          <Text size="lg2" align="center">
            <Trans
              i18nKey="frames.MaintenanceFrame.description1"
              tOptions={{ lng: 'ja' }}
            />
          </Text>
          <Text size="lg2" align="center">
            <Trans
              i18nKey={
                phoneNumber
                  ? 'frames.MaintenanceFrame.description2'
                  : 'frames.MaintenanceFrame.phoneNotFound'
              }
              tOptions={{ lng: 'ja' }}
            />
          </Text>
        </div>
        <div>
          <Text size="lg2" weight="bold" align="center">
            <Trans
              i18nKey="frames.MaintenanceFrame.information"
              tOptions={{ lng: 'en' }}
            />
          </Text>
          <Text size="lg2" align="center">
            <Trans
              i18nKey="frames.MaintenanceFrame.description1"
              tOptions={{ lng: 'en' }}
            />
          </Text>
          <Text size="lg2" align="center">
            <Trans
              i18nKey={
                phoneNumber
                  ? 'frames.MaintenanceFrame.description2'
                  : 'frames.MaintenanceFrame.phoneNotFound'
              }
              tOptions={{ lng: 'en' }}
            />
          </Text>
        </div>
        {phoneNumber && (
          <div>
            <Text size="lg6" weight="bold" align="center">
              <MdPhone className="inline relative right-[5px] top-[-3px]" />
              {phoneNumber}
            </Text>
          </div>
        )}
      </div>
    </Layout>
  )
}
